import * as React from "react";
import ModelContainer from "../../../components/model/ModelContainer";
import PageTitle from "../../../components/model/PageTitle";
import ModelTitle from "../../../components/model/ModelTitle";
import ModelInfo from "../../../components/model/ModelInfo";
import {GAEventModels} from "../../../utils/SendGAEvent";
import ModelDescription from "../../../components/model/ModelDescription";
import NERModel from "./NERModel";
import Disclaimer from "../../../components/model/Disclaimer";
import TabPanel from "../../../components/model/TabPanel";

const NamedEntityRecognition = () => {
  return <ModelContainer>
        <PageTitle/>
        <div>
            <ModelTitle>Named Entity Recognition</ModelTitle>
            <ModelInfo model={GAEventModels.NAMED_ENTITY_RECOGNITION}/>
            <TabPanel
                modelName={GAEventModels.NAMED_ENTITY_RECOGNITION}
                modelDescription={<ModelDescription>Outputs recognized named entities. Maximum size of input is 1000 words.</ModelDescription>}
                content={<NERModel/>}
            />
            <Disclaimer/>
        </div>
    </ModelContainer>;
};

export default NamedEntityRecognition


// WEBPACK FOOTER //
// ./src/routes/Dashboard/NamedEntityRecognition/index.tsx